import type { CSSProperties } from 'react';
import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router';
import { useI18nContext } from '@/i18n/i18n-react';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

export function CampaignAudienceCard({
  audience,
  tenantSlug,
  className,
  style,
}: {
  audience: { id: string; name: string } | null;
  tenantSlug: string;
  className?: string;
  style?: CSSProperties;
}) {
  const { LL } = useI18nContext();

  const name =
    audience?.name ?? LL.createCampaign.sections.audience.entireUserbase();

  const content = (
    <>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-medium text-muted-foreground">
          {LL.campaignDetails.audience()}
        </p>
        <p className="truncate text-sm font-medium">{name}</p>
      </div>
      {audience ? (
        <ChevronRight className="size-4 shrink-0 text-primary" />
      ) : null}
    </>
  );

  if (audience) {
    return (
      <Card
        className={cn(
          'w-full overflow-hidden transition-colors hover:bg-accent/50',
          className
        )}
        style={style}
      >
        <Link
          to={`/${tenantSlug}/audiences/${audience.id}`}
          className="flex w-full items-center gap-3 px-4 py-3"
        >
          {content}
        </Link>
      </Card>
    );
  }

  return (
    <Card className={cn('w-full overflow-hidden', className)} style={style}>
      <div className="flex w-full items-center gap-3 px-4 py-3">{content}</div>
    </Card>
  );
}
